import {
  AnemiaProtocol,
  CardiacStressTestProtocol,
  EarlyPostopProtocol,
  GenericPrescriptionProtocol,
  NicotineProtocol,
  NutritionPrescriptionProtocol,
  PostopChronicPainProtocol,
  PreopChronicPainProtocol,
  PreopLabTestProtocol,
  Protocol,
  ProtocolName,
  SleepApneaProtocol,
  SurgeryPlanningProtocol,
  TelehealthProtocol,
  useProtocolQuery
} from '@/modules/protocol';
import {
  useQueryForCurrentPatient,
  UseQueryForCurrentPatientParam
} from '@/hooks';
import { QueryResultLike } from '@/modules/surgicalEvent/util';

type ProtocolForName<P extends ProtocolName> =
  P extends ProtocolName.GENERIC_PRESCRIPTION
    ? GenericPrescriptionProtocol
    : P extends ProtocolName.NICOTINE
    ? NicotineProtocol
    : P extends ProtocolName.PREOP_LAB_TEST
    ? PreopLabTestProtocol
    : P extends ProtocolName.CARDIAC_STRESS_TEST
    ? CardiacStressTestProtocol
    : P extends ProtocolName.NUTRITION
    ? NutritionPrescriptionProtocol
    : P extends ProtocolName.ANEMIA
    ? AnemiaProtocol
    : P extends ProtocolName.SLEEP_APNEA
    ? SleepApneaProtocol
    : P extends ProtocolName.TELEHEALTH
    ? TelehealthProtocol
    : P extends ProtocolName.SURGERY_PLANNING
    ? SurgeryPlanningProtocol
    : P extends ProtocolName.EARLY_POSTOP
    ? EarlyPostopProtocol
    : P extends ProtocolName.PREOP_CHRONIC_PAIN
    ? PreopChronicPainProtocol
    : P extends ProtocolName.POSTOP_CHRONIC_PAIN
    ? PostopChronicPainProtocol
    : Protocol;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ReturnValue<P extends ProtocolName> = ReturnType<typeof useProtocolQuery> &
  QueryResultLike<ProtocolForName<P>>;
type PollingConfig = UseQueryForCurrentPatientParam<any, any>['pollingInView'];

export const useCurrentProtocol = <P extends ProtocolName>(
  protocolName: P,
  pollingInView?: PollingConfig
) =>
  useQueryForCurrentPatient<ProtocolForName<P>, { protocolName: ProtocolName }>(
    {
      useQuery: useProtocolQuery as any,
      queryArg: { protocolName },
      pollingInView
    }
  );
